import { render } from "./vehicleList.vue?vue&type=template&id=2d305242&scoped=true"
import script from "./vehicleList.vue?vue&type=script&lang=js"
export * from "./vehicleList.vue?vue&type=script&lang=js"

import "./vehicleList.vue?vue&type=style&index=0&id=2d305242&scoped=true&lang=css"

import exportComponent from "C:\\Users\\DELL\\source\\repos\\project0810frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d305242"]])